import React from 'react'
import ContactUS from './ContactUS'

import './index.css'

const FormComponent = () => {
    return (
          <div className="form-fluid">
              <ContactUS />
          </div>

    )
}

export default FormComponent
